export interface QuestionOption {
  label: string;
  value: string;
  score: number;
  url?: string;
}

export interface Question {
  id: number;
  question: string;
  type: "single" | "multiple" | "text";
  options: QuestionOption[];
  placeholder?: string;
  isDynamic?: boolean;
  dependsOn?: number;
  dynamicLoader?: string;
  showOnlyIf?: string;
  isOptional?: boolean;
  metadata?: {
    logo?: string;
    companyName?: string;
    linkedinUrl?: string;
    enrichedData?: {
      linkedinUrl: string;
      title: string;
      score: number;
      logo?: string | null;
      followerCount?: number | null;
      employeeCount?: number | null;
      description?: string | null;
      industry?: string | null;
      avgEngagement?: number | null;
      postingFrequency?: string | null;
      recentPostsCount?: number;
      enriched?: boolean;
      founded?: number | null;
      headquarters?: string | null;
      website?: string | null;
      company_size?: string | null;
      locations?: string[];
      country_code?: string | null;
      specialties?: string | null;
      slogan?: string | null;
      organization_type?: string | null;
      company_id?: string | null;
      _raw?: any;
    };
  };
}

export const questions: Question[] = [
  {
    id: 1,
    question: "Czy posiadasz profil na LinkedIn?",
    type: "single",
    options: [
      { label: "Tak", value: "yes", score: 1.2 },
      { label: "Tak jestem, ale nie jestem aktywny", value: "inactive", score: 0.5 },
      { label: "Nie", value: "no", score: 0 },
      { label: "Ktoś z firmy jest na LinkedIn", value: "someone", score: 0.3 },
    ],
  },
  {
    id: 2,
    question: "W jakim sektorze działasz?",
    type: "single",
    options: [
      { label: "B2B (Business to Business)", value: "b2b", score: 1.5 },
      { label: "B2G (Business to Government)", value: "b2g", score: 1.5 },
      { label: "Przetargi (Tender Sales)", value: "tender", score: 0 },
      { label: "D2C (Direct to Consumer)", value: "d2c", score: 1.5 },
      { label: "B2C (Business to Consumer)", value: "b2c", score: 0 },
      { label: "E-commerce", value: "ecommerce", score: 0 },
    ],
  },
  {
    id: 3,
    question: "Ilu ludzi realnie zajmuje się sprzedażą w Twojej firmie?",
    type: "single",
    options: [
      { label: "5 lub więcej", value: "5plus", score: 1.0 },
      { label: "2–4", value: "2to4", score: 0.6 },
      { label: "1 osoba", value: "1person", score: 0 },
      { label: "Tylko ja", value: "only_me", score: 0 },
    ],
  },
  {
    id: 4,
    question: "Jaka jest strona internetowa Twojej firmy?",
    type: "text",
    placeholder: "np. microsoft.com lub www.microsoft.com",
    options: [],
    isOptional: true
  },
  {
    id: 5,
    question: "Czy śledzicie źródło pochodzenia leadów (np. reklama, polecenia, blog, targi, wydarzenia)?",
    type: "single",
    options: [
      { label: "Tak, szczegółowo analizujemy", value: "detailed", score: 1.5 },
      { label: "Tak, ale ogólnie", value: "general", score: 0.8 },
      { label: "Nie śledzimy", value: "none", score: 0 }
    ]
  },
  {
    id: 6,
    question: "Czy posiadacie Sales Navigator lub Premium na LinkedIn?",
    type: "single",
    options: [
      { label: "Tak, Sales Navigator", value: "sales_nav", score: 1.5 },
      { label: "Tak, Premium", value: "premium", score: 0.8 },
      { label: "Nie, tylko konto darmowe", value: "free", score: 0 },
      { label: "Nie mamy LinkedIn", value: "none", score: -1 },
      { label: "Nie wiem", value: "dont_know", score: 0 }
    ]
  },
  {
    id: 7,
    question: "Czy używacie CRMa/sprzedażowych narzędzi?",
    type: "single",
    options: [
      { label: "Mamy wdrożony CRM i aktywnie go używamy", value: "crm_active", score: 1.5 },
      { label: "Mamy CRM, ale nie jest w pełni wykorzystywany", value: "crm_partial", score: 0.8 },
      { label: "Używamy prostych narzędzi (Excel, Google Sheets)", value: "spreadsheets", score: 0.2 },
      { label: "Nie używamy żadnych narzędzi", value: "no_tools", score: 0 },
      { label: "Inne", value: "other", score: 0.4 },
    ],
  },
  {
    id: 8,
    question: "Jaka jest roczna wartość typowego kontraktu (ACV - annual contract value)?",
    type: "single",
    options: [
      { label: "> 50 000 PLN", value: "over_50k", score: 1.8 },
      { label: "10–50 000 PLN", value: "10to50k", score: 1.0 },
      { label: "< 10 000 PLN", value: "under_10k", score: 0.3 },
      { label: "Nie wiem", value: "dont_know", score: 0 },
      { label: "Nie powiem", value: "wont_say", score: 0 },
    ],
  },
  {
    id: 9,
    question: "Ile trwa średnio cykl sprzedaży?",
    type: "single",
    options: [
      { label: "Do 3 miesięcy", value: "3months", score: 0.4 },
      { label: "Do 6 miesięcy", value: "6months", score: 0.6 },
      { label: "Do 1 roku", value: "1year", score: 1.0 },
      { label: "Powyżej roku", value: "over_1year", score: 1.2 },
    ],
  },
  {
    id: 10,
    question: "Czy macie zdefiniowane ICP (idealnego klienta) i listę np. 500+ kont?",
    type: "single",
    options: [
      { label: "Tak", value: "yes", score: 2.5 },
      { label: "W trakcie", value: "in_progress", score: 1.2 },
      { label: "Nie", value: "no", score: 0.2 },
      { label: "Nie wiem", value: "dont_know", score: 0 },
      { label: "A po co mi to..", value: "why_need", score: 0 },
    ],
  },
  {
    id: 11,
    question: "Które kanały sprzedaży obecnie generują najwięcej sprzedaży?",
    type: "multiple",
    options: [
      { label: "Cold outreach / e-mail", value: "cold_email", score: 0.4 },
      { label: "Polecenia", value: "referrals", score: 0.25 },
      { label: "Inbound z reklam lub strony", value: "inbound", score: 0.4 },
      { label: "Targi/eventy", value: "events", score: 0.25 },
      { label: "Telefon", value: "phone", score: 0.25 },
      { label: "Partnerzy, dystrybutorzy", value: "partners", score: 0.3 },
      { label: "Inne", value: "other", score: 0.15 },
      { label: "Nie wiem", value: "dont_know", score: 0 },
    ],
  },
  {
    id: 12,
    question: "Ile teraz wydajesz na marketing i sprzedaż miesięcznie?",
    type: "single",
    options: [
      { label: "Powyżej 50 tys.", value: "above_50k", score: 2.0 },
      { label: "Od 30 do 49 tys.", value: "30to49k", score: 1.7 },
      { label: "Od 10 do 29 tys.", value: "10to29k", score: 1.4 },
      { label: "Pomiędzy 5 a 9 tys.", value: "5to9k", score: 1.0 },
      { label: "Pomiędzy 2-4 tys.", value: "2to4k", score: 0.7 },
      { label: "Mniej niż 2 tys.", value: "below_2k", score: 0.4 },
    ],
  },
  {
    id: 13,
    question: "Czy używacie automatyzacji/AI w firmie?",
    type: "single",
    options: [
      { label: "Tak", value: "yes", score: 1.2 },
      { label: "Nie", value: "no", score: 0 },
      { label: "Nie wiem", value: "dont_know", score: 0 },
    ],
  },
  {
    id: 14,
    question: "Czy znasz takie pojęcia i je rozumiesz? (zaznacz wszystkie, które znasz i rozumiesz)",
    type: "multiple",
    options: [
      { label: "Prospecting (aktywne generowanie kontaktów do sprzedaży)", value: "prospecting", score: 0.167 },
      { label: "Inbound (przychodzący marketing)", value: "inbound", score: 0.167 },
      { label: "Outbound (wychodzący marketing)", value: "outbound", score: 0.167 },
      { label: "Lead Generation (generowanie leadów)", value: "lead_gen", score: 0.167 },
      { label: "PPC (Pay Per Click)", value: "ppc", score: 0.167 },
      { label: "Demand Generation (budowanie popytu)", value: "demand_gen", score: 0.167 },
      { label: "ICP (Ideal Client Profile – profil idealnego klienta)", value: "icp", score: 0.167 },
      { label: "ABM/S (Account-Based Marketing/Sales – marketing/sprzedaż oparta na kontach)", value: "abm", score: 0.167 },
      { label: "Cold Outreach (zimny kontakt)", value: "cold_outreach", score: 0.167 },
      { label: "Sales Funnel / Pipeline (lejek sprzedażowy)", value: "funnel", score: 0.167 },
      { label: "Discovery Call (rozmowa odkrywcza)", value: "discovery", score: 0.167 },
      { label: "Marka osobista / Social Selling", value: "personal_brand", score: 0.167 },
      { label: "BANT (Budget Authority, Need, Timing)", value: "bant", score: 0.167 },
      { label: "Branding", value: "branding", score: 0.167 },
    ],
  },
  {
    id: 15,
    question: "Jak oceniasz potencjał LinkedIna dla Twojej firmy?",
    type: "single",
    options: [
      { label: "Duży, rynek tam już jest", value: "high", score: 1.0 },
      { label: "Ciekawy, ale potrzebuję danych", value: "interesting", score: 0.6 },
      { label: "Konkurencja mocno tam działa", value: "competitive", score: 0.8 },
      { label: "Nie wiem / sceptycznie", value: "skeptical", score: 0 },
    ],
  },
  {
    id: 16,
    question: "Które z tych firm konkurencyjnych znasz?",
    type: "multiple",
    isDynamic: true,
    dependsOn: 4,
    dynamicLoader: "find-competitors",
    options: []
  },
  {
    id: 17,
    question: "Czy to jest profil LinkedIn Waszej firmy?",
    type: "single",
    isDynamic: true,
    dependsOn: 4,
    dynamicLoader: "linkedin-company-profile",
    options: [
      { label: "Tak, to nasz profil", value: "yes", score: 0 },
      { label: "Nie, to nie nasz profil", value: "no", score: 0 },
      { label: "Nie posiadamy profilu firmowego na LinkedIn", value: "no_profile", score: 0 },
    ]
  },
];

import { interstitials } from "./interstitials";

const interstitialIds = new Set<number>(Object.keys(interstitials).map(Number));

export const calculateScore = (answers: Record<number, string | string[]>): number => {
  let totalScore = 0;
  let maxPossible = 0;

  questions.forEach((question) => {
    // Skip text inputs, dynamic questions, interstitials, Q15 (LinkedIn potential), and Q17 (LinkedIn profile confirmation)
    if (question.type === 'text' || question.isDynamic || interstitialIds.has(question.id) || question.id === 15 || question.id === 17) return;
    
    // Skip questions that don't meet showOnlyIf conditions
    if (question.dependsOn !== undefined && question.showOnlyIf !== undefined) {
      const dependentAnswer = answers[question.dependsOn];
      if (dependentAnswer !== question.showOnlyIf) return;
    }
    
    const answer = answers[question.id];
    
    // Calculate max possible score for this question
    if (question.type === "single") {
      maxPossible += Math.max(...question.options.map(opt => opt.score));
    } else if (question.type === "multiple") {
      // For multiple choice, sum all positive scores
      maxPossible += question.options.filter(opt => opt.score > 0).reduce((sum, opt) => sum + opt.score, 0);
    }
    
    if (!answer) return;

    if (question.type === "single" && typeof answer === "string") {
      const selectedOption = question.options.find((opt) => opt.value === answer);
      if (selectedOption) {
        totalScore += selectedOption.score;
      }
    } else if (question.type === "multiple" && Array.isArray(answer)) {
      answer.forEach((selectedValue) => {
        const selectedOption = question.options.find((opt) => opt.value === selectedValue);
        if (selectedOption) {
          totalScore += selectedOption.score;
        }
      });
    }
  });

  // Normalize to 1-10 scale using dynamic max
  const normalizedScore = maxPossible > 0 
    ? Math.min(10, Math.max(1, (totalScore / maxPossible) * 10))
    : 1;
  
  return Math.round(normalizedScore * 10) / 10;
};

export const getScoreBand = (score: number): 'low' | 'mid' | 'high' => {
  if (score <= 4) return 'low';
  if (score <= 7) return 'mid';
  return 'high';
};